import { z } from "zod";
import { pagedResponse, paginationQuerySchema } from "../common/pagination.js";
import { PRODUCT_IMPORT_COLUMNS } from "../product-imports/product-imports.schemas.js";
/**
 * The export uses the SAME column spec as the import so an exported file can be
 * edited and re-imported (round-trip). Re-exported under an export-scoped name
 * so callers don't have to reach across modules.
 */
export const PRODUCT_EXPORT_COLUMNS = PRODUCT_IMPORT_COLUMNS;
/** Filters applied to the product set being exported — parity with the products list. */
export const exportFilters = z.object({
    categoryIds: z.array(z.string().uuid()).optional(),
    brand: z.string().optional(),
    isActive: z.boolean().optional(),
    imageless: z.boolean().optional(),
    search: z.string().max(255).optional(),
});
export const createProductExportRequest = z
    .object({
    format: z.enum(["csv", "xlsx"]),
    filters: exportFilters.optional().default({}),
    /** When true, email `notifyEmail` on completion. */
    notify: z.boolean().optional().default(false),
    notifyEmail: z.string().email().nullish(),
})
    .refine((v) => !v.notify || Boolean(v.notifyEmail), {
    message: "A valid email is required when notify is enabled",
    path: ["notifyEmail"],
});
export const productExportStatus = z.enum([
    "queued",
    "processing",
    "completed",
    "failed",
    "cancelled",
]);
export const productExportInfo = z.object({
    id: z.string().uuid(),
    status: productExportStatus,
    format: z.enum(["csv", "xlsx"]),
    /** Actual format produced — xlsx may fall back to csv above the row cap. */
    effectiveFormat: z.enum(["csv", "xlsx"]).nullable(),
    filters: exportFilters,
    totalRows: z.number().int(),
    exportedRows: z.number().int(),
    /** Presigned download URL, present once completed. */
    resultUrl: z.string().nullable(),
    resultFilename: z.string().nullable(),
    notifyEmail: z.string().nullable(),
    errorSummary: z.string().nullable(),
    createdAt: z.string().datetime(),
    completedAt: z.string().datetime().nullable(),
});
export const productExportsListResponse = pagedResponse(productExportInfo);
export const listProductExportsQuery = paginationQuerySchema;
export const createProductExportResponse = productExportInfo;
export const cancelProductExportResponse = productExportInfo;
//# sourceMappingURL=product-exports.schemas.js.map